import React from "react"
import StyledBottomMenu from "./BottomMenu.style"
import { usePrimaryMenuData } from "../../particles/hooks/usePrimaryMenuData"
import Menu from "../Menu/Menu"
import Content from "../../particles/Content"

const BottomMenu = () => {
  const primaryMenu = usePrimaryMenuData()

  return (
    <StyledBottomMenu className="main-menu">
      <Content className="content">
        <Menu fontColor="#5D412D" menuItems={[...primaryMenu]} logo />
      </Content>
    </StyledBottomMenu>
  )
}

export default BottomMenu
